/**
 * Scroll Animations — Intersection Observer-based reveal + count-up.
 * No dependencies. Respects prefers-reduced-motion.
 */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ── Scroll Reveal ── */
  var revealEls = document.querySelectorAll('.reveal, .reveal--left, .reveal--right, .reveal--scale, .reveal-stagger');

  if (revealEls.length) {
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    revealEls.forEach(function (el) {
      revealObserver.observe(el);
    });
  }

  /* ── Count-Up Animation ── */
  var countEls = document.querySelectorAll('.count-up');

  if (countEls.length) {
    var countObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCount(entry.target);
            countObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    countEls.forEach(function (el) {
      countObserver.observe(el);
    });
  }

  function animateCount(el) {
    var text = el.textContent.trim();
    // Extract the numeric part and suffix (e.g. "7000+" → 7000, "+")
    var match = text.match(/^([\d,]+)(.*)/);
    if (!match) return;

    var target = parseInt(match[1].replace(/,/g, ''), 10);
    var suffix = match[2]; // e.g. "+", "x", "%"
    var duration = 1600; // ms
    var startTime = null;

    // Easing: ease-out cubic
    function easeOut(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var easedProgress = easeOut(progress);
      var current = Math.round(easedProgress * target);

      // Format with commas for large numbers
      el.textContent = current.toLocaleString() + suffix;

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    }

    // Start from 0
    el.textContent = '0' + suffix;
    requestAnimationFrame(step);
  }
})();
